<!--
  The overview table. This is a port of CGS2022 analysisOverviewCard.vue: one row per loan type
  and per channel, each row being insightStatistics found by `title`, set against the same
  title in insightTrendStatistics.

  `groups`: [{ label: 'By loan type', rows: [{ display, value }] }, …], i.e. CGS's
  typeRowTitles and channelRowTitles.
  `columns`: [{ prop, label, format, lowerIsBetter }]. The default is CGS's: Units, Volume,
  Avg FICO, Avg Rate, Avg LTV, Avg Loan Amount. Investor/Shipping adds Avg DOL.

  As in CGS, a row the API didn't return is left out.
-->
<template>
  <div class="ins-card__scroll">
    <table class="ins-table">
      <thead>
        <tr>
          <th scope="col">Segment</th>
          <th v-for="c in columns" :key="c.prop" scope="col">{{ c.label }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="g in built" :key="g.label">
          <tr v-if="g.label" class="ins-group"><td :colspan="columns.length + 1">{{ g.label }}</td></tr>
          <tr v-for="r in g.rows" :key="g.label + r.value">
            <td>{{ r.label }}</td>
            <td v-for="c in columns" :key="c.prop">
              {{ formatAs(r.cur[c.prop], c.format) }}
              <TrendDelta v-if="showTrend && r.prev" :cur="r.cur[c.prop]" :prev="r.prev[c.prop]" :format="c.format" :lower-is-better="c.lowerIsBetter" :show-pct="false" :label="`Trend ${c.label}`" />
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import TrendDelta from './TrendDelta.vue'
import { statRows, formatAs } from '@/helpers/insights/insightMath.js'

export const DEFAULT_STAT_COLUMNS = [
  { prop: 'units', label: 'Units', format: 'int' },
  { prop: 'volume', label: 'Volume', format: 'cur' },
  { prop: 'avgfico', label: 'Avg FICO', format: 'dec' },
  { prop: 'avgrate', label: 'Avg Rate', format: 'dec' },
  { prop: 'avgltv', label: 'Avg LTV', format: 'dec' },
  { prop: 'avgloanamount', label: 'Avg Loan Amount', format: 'cur' }
]

export default {
  name: 'StatTable',
  components: { TrendDelta },
  props: {
    groups: { type: Array, required: true },
    stats: { type: Array, default: () => [] },
    trendStats: { type: Array, default: () => [] },
    columns: { type: Array, default: () => DEFAULT_STAT_COLUMNS },
    showTrend: { type: Boolean, default: true }
  },
  computed: {
    built() {
      return this.groups.map(g => ({
        label: g.label,
        rows: statRows(g.rows, this.stats, this.trendStats).filter(r => r.cur)
      })).filter(g => g.rows.length)
    }
  },
  methods: { formatAs }
}
</script>
